import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "./components/ckeditor-content.css";

const CKEditorFormEditor = ({ value = "", onChange }) => {
  return (
    <CKEditor
      editor={ClassicEditor}
      data={value}
      onChange={(_, editor) => {
        const data = editor.getData();
        onChange?.(data);
      }}
      config={{
        toolbar: [
          "undo", "redo", "|",
          "heading", "|",
          "fontSize", "fontFamily", "|",
          "bold", "italic", "link", "blockQuote", "|",
          "bulletedList", "numberedList", "outdent", "indent", "|",
          "insertTable", "mediaEmbed"
        ],
        fontSize: {
          options: [
            12, 14, 16, 18, 20, 24, 28, 32, 36, 40, 48, 50,
            "default"
          ],
          supportAllValues: true,
        },
        fontFamily: {
          options: ["default", "Arial", "Helvetica", "Georgia", "Courier New"],
        },
      }}
    />
  );
};

export default CKEditorFormEditor;
